import { render, staticRenderFns } from "./Compare01.vue?vue&type=template&id=7f61b0f6&"
import script from "./Compare01.vue?vue&type=script&lang=ts&"
export * from "./Compare01.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports